module.exports = __webpack_public_path__ + "static/media/icons_Bilan Syndr“me d_Hyperventilation.a01ccc55.svg";